module.exports = __webpack_public_path__ + "media/images/proposal/hall-list/proposal-halllist-5-b217dbfc65f7b7941241bae68b8e58f7.jpg";